import React from 'react';
import { useGame } from '../context/GameContext';

const LoadingOverlay = () => {
  const { isLoading, translations, lang } = useGame();

  if (!isLoading) return null;

  return (
    <div className="loading-overlay-container">
      <div className="spinner-border text-light" role="status">
        <span className="visually-hidden">{translations[lang]?.loading_text}</span>
      </div>
      <p className="ms-3">{translations[lang]?.loading_text}</p>
    </div>
  );
};

export default LoadingOverlay;
